import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { useAppStore } from "../../stores/RootStore";
import { useScreenStore } from "../../stores/ScreenStore";
import { Button } from "../../ui/Button";
import { Separator } from "../../ui/Separator";
import MonitoringGrid from "./MonitoringGrid";
import AddScreen from "./Screen/AddScreen";
import RoleRequire from "../../helpers/auth/RoleRequire";
import { useEffect } from "react";

export const Monitoring = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const { isEditMode, setIsEditMode, monitor,  resetStore } = useScreenStore()
  const currentSite = useAppStore().currentSite

  useEffect(() => {
    resetStore()
  }, [id])

  function changeMode() {
    if(isEditMode) {
      resetStore()
      setIsEditMode(!isEditMode)
    } else {
      setIsEditMode(!isEditMode)
    }
  }

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full bg-muted">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          {location.pathname == "/monitoring" || location.pathname == "/monitoring/" ? <span className="font-medium">{t("monitoring")}</span> : <NavLink to={"/monitoring"} onClick={()=>resetStore()}><span className="font-medium">{t("monitoring")}</span></NavLink>}
          {(monitor || location.pathname == "/monitoring/new") && <span>/</span>}
          {monitor && <span>{monitor?.attributes.name}</span>}
          {location.pathname == "/monitoring/new" && <span>{t('adding_screen')}</span>}
        </div>
        <RoleRequire role="maintainer">
          {location.pathname == "/monitoring/new" || location.pathname == "/monitoring/new/" || location.pathname == "/monitoring/" || location.pathname == "/monitoring" ? <></> : <div>
            <Button variant={"outline"} size={"datepicker"} onClick={() => changeMode()}>{isEditMode ? t('monitoring_mode_screen') : t('edit_mode_screen')}</Button>
          </div>}
        </RoleRequire>
      </div>
      <Separator className="flex-none"/>
      {
        location.pathname == "/monitoring/new" || location.pathname == "/monitoring/new/" ? <AddScreen /> : 
        id ? <Outlet context={[id, isEditMode]}/> :
        <div className="flex w-full h-full bg-background">
          <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
            <Header name={t('monitoring')} backName={currentSite?.name ? currentSite?.name : "..."} backLink={"/"}/>
            <MonitoringGrid onClose={empty}/>
          </div>
        </div>
      }
    </div>
  )
};
